export default "/assets/images/wcf-v1.c3d7332b456437b8.webp";